<template>
  <div class="rsa">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="RSA公私钥生成" name="first">
        <div class="rsa-con clearfix">
          <div class="rsa-left">
            <h3>RSA加密公钥</h3>
            <el-input v-model="publicKey" type="textarea" :rows="14" />
          </div>
          <div class="rsa-right">
            <h3>RSA加密私钥</h3>
            <el-input v-model="privateKey" type="textarea" :rows="14" />
          </div>
        </div>
        <div class="btn">
          <span>秘钥长度：</span>
          <el-select v-model="ob.len" placeholder="请选择秘钥长度">
            <el-option 
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              >
            </el-option>
          </el-select>
          <el-button type="primary"  @click="save">生成公私秘钥</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="根据公钥加密文本" name="second">
        <div class="rsa-con">
          <div class="rsa-left">
            <h3>请输入公钥</h3>
            <el-input v-model="encryptionPublicKey" type="textarea" :rows="10" />
            <h3>请输入要加密的字符串</h3>
            <el-input v-model="encryptionStr" type="textarea" :rows="10" />
          </div>
          <div class="rsa-right">
            <h3>加密文本</h3>
            <el-input v-model="encryptionText" type="textarea" :rows="20" />
            <div class="btn">
              <el-button type="primary" @click="encryptionSave">执行</el-button>
              <el-button  @click="encryptionClear">清空</el-button>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="根据私钥解密文本" name="third">
        <div class="rsa-con">
          <div class="rsa-left">
            <h3>请输入私钥</h3>
            <el-input v-model="decryptPrivateKey" type="textarea" :rows="10" />
            <h3>请输入要解密的签名</h3>
            <el-input v-model="decryptStr" type="textarea" :rows="10" />
          </div>
        </div>
        <div class="rsa-con">
          <div class="rsa-right">
            <h3>解密文本</h3>
            <el-input v-model="decryptText" type="textarea" :rows="20" />
            <div class="btn">
              <el-button type="primary" @click="decryptSave">执行</el-button>
              <el-button  @click="decryptClear">清空</el-button>
            </div>
          </div>
        </div>
        
        
        
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import getRsaKeys from '@/utils/rsa.js'
import { JSEncrypt } from 'jsencrypt'
export default {
  data () {
    return {
      publicKey: '',
      privateKey: '',
      activeName: 'first',
      ob: {
        len: ''
      },
      keyLength: '',
      options: [
        {
          value: 1024,
          label: '1024 bit'
        },
        {
          value: 2048,
          label: '2048 bit'
        },
        {
          value: 4096,
          label: '4096 bit'
        }
      ],

      encryptionPublicKey: '',
      encryptionStr: '',
      encryptionText: '',

      decryptPrivateKey: '',
      decryptStr: '',
      decryptText: ''
    }
  },
  methods: {
    save () {
      getRsaKeys(( p1, p2) => {
        console.log(p1)
        console.log(p2)
        this.publicKey = p2
        this.privateKey = p1
      }, this.ob)
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    // 加密
    encryptionSave () {
      if (this.encryptionPublicKey === '') return
      let encryptor = new JSEncrypt()
      // 设置公钥
      encryptor.setPublicKey(this.encryptionPublicKey)
      // 加密数据
      this.encryptionText = encryptor.encrypt(this.encryptionStr)
    },
    // 加密清空
    encryptionClear () {
      this.encryptionPublicKey = ''
      this.encryptionStr = ''
      this.encryptionText = ''
    },

    // 解密
    decryptSave () {
      if (this.decryptPrivateKey === '') return
      let decrypt = new JSEncrypt()
      // 设置私钥
      decrypt.setPrivateKey(this.decryptPrivateKey)
      // 解密数据
      this.decryptText = decrypt.decrypt(this.decryptStr)
    },
    // 解密清空
    decryptClear () {
      this.decryptPrivateKey = ''
      this.decryptStr = ''
      this.decryptText = ''
    }
  }
}
</script>
<style lang="stylus" scope>
.rsa
  h3
    margin 10px 0
  .btn
    margin-top 22px
    .el-select
      margin-right 10px  

.rsa-con
  .rsa-left
    float left
    width 49%
  .rsa-right
    float right
    width 49%   
</style>